import React, { useEffect, useState } from "react";
import { api } from "../utils/api";
import { toast } from "react-hot-toast";

const BTN_BLUE = "inline-flex items-center justify-center rounded-lg font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400/60 shadow-none";

export default function AdminMaintenance() {
    const [enabled, setEnabled] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const meta = await api("/meta/site");
                setEnabled(!!meta?.maintenance?.enabled);
                setMessage(meta?.maintenance?.message || "");
            } catch {
                // bỏ qua
            }
        })();
    }, []);

    async function save() {
        const payload = {
            maintenance: {
                enabled,
                message: message || "Hệ thống đang bảo trì. Vui lòng quay lại sau.",
            },
        };
        await api("/meta/site", { method: "PUT", data: payload });
        toast.success("Đã lưu cài đặt bảo trì.");
    }

    return (
        <div className="max-w-xl mx-auto p-4 sm:p-6">
            <h1 className="text-xl sm:text-2xl font-bold mb-4">Bảo trì hệ thống</h1>
            <div className="bg-white border rounded-2xl shadow-sm p-4 grid gap-4">
                <label className="flex items-center gap-3">
                    <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
                    <span>Bật chế độ bảo trì</span>
                </label>

                <div>
                    <label className="block text-sm mb-1">Thông báo cho người dùng</label>
                    <textarea
                        className="w-full p-3 border rounded-xl"
                        rows={3}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Hệ thống đang bảo trì. Vui lòng quay lại sau."
                    />
                </div>

                <div className="flex gap-2">
                    <button className={`${BTN_BLUE} px-4 py-2`} onClick={save}>Lưu</button>
                    <button
                        className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200"
                        onClick={() => { setEnabled(false); setMessage(""); }}
                    >
                        Huỷ thay đổi
                    </button>
                </div>

                <div className="text-sm text-gray-500">
                    Khi bật, mọi người dùng (trừ admin) vào site sẽ thấy trang bảo trì. Admin vẫn truy cập bình thường để tắt.
                </div>
            </div>
        </div>
    );
}
